import {
  HIDE_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  RECEIVE_NOTIFICATIONS,
  MARK_ALL_AS_READ,
  RECEIVE_PUSH_NOTIFICATION
} from './actions/types';

const initialState = {
  notificationList: [],
  unreadCount:      0
};

function buildState(notificationList) {
  return ({
    notificationList: notificationList,
    unreadCount:      unreadNotificationsCount(notificationList)
  });
}

function unreadNotificationsCount(notificationList) {
  return notificationList.reduce((total, notification) => {
    return total + (notification.unread ? 1 : 0);
  }, 0);
}

function hideNotification(state, id) {
  const notificationList = state.notificationList.filter((notification) => {
    return id !== notification.id;
  });
  return buildState(notificationList);
}

function markAllAsRead(state) {
  const notificationList = state.notificationList.map((notification) => {
    notification.unread = false;
    return notification;
  });
  return { notificationList, unreadCount: 0 };
}

function markNotificationRead(state, id) {
  const notificationList = state.notificationList.map((notification) => {
    if (notification.id === id) {
      notification.unread = false;
    }
    return notification;
  });
  return buildState(notificationList);
}

function addNotification(state, notification) {
  return notification ? buildState([notification, ...state.notificationList]) : state;
}

export function reducer(state = initialState, action) {
  switch (action.type) {
  case HIDE_NOTIFICATION:
    return hideNotification(state, action.payload.id);
  case MARK_ALL_AS_READ:
    return markAllAsRead(state);
  case MARK_NOTIFICATION_READ:
    return markNotificationRead(state, action.payload.id);
  case RECEIVE_NOTIFICATIONS:
    return buildState(action.payload.notificationList);
  case RECEIVE_PUSH_NOTIFICATION:
    return addNotification(state, action.payload.notification);
  default:
    return state;
  }
}
